// @generated by protoc-gen-es v1.10.1 with parameter "target=ts"
// @generated from file knop/ui/v1/model/blocked_infrastructures.proto (package knop.ui.v1.model, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3, Timestamp } from "@bufbuild/protobuf";
import { DisabledTrack } from "./disabled_track_pb.js";

/**
 * @generated from message knop.ui.v1.model.BlockedInfrastructures
 */
export class BlockedInfrastructures extends Message<BlockedInfrastructures> {
  /**
   * @generated from field: google.protobuf.Timestamp start_time = 1;
   */
  startTime?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp end_time = 2;
   */
  endTime?: Timestamp;

  /**
   * @generated from field: repeated knop.ui.v1.model.DisabledTrack tracks = 3;
   */
  tracks: DisabledTrack[] = [];

  constructor(data?: PartialMessage<BlockedInfrastructures>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "knop.ui.v1.model.BlockedInfrastructures";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "start_time", kind: "message", T: Timestamp },
    { no: 2, name: "end_time", kind: "message", T: Timestamp },
    { no: 3, name: "tracks", kind: "message", T: DisabledTrack, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): BlockedInfrastructures {
    return new BlockedInfrastructures().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): BlockedInfrastructures {
    return new BlockedInfrastructures().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): BlockedInfrastructures {
    return new BlockedInfrastructures().fromJsonString(jsonString, options);
  }

  static equals(a: BlockedInfrastructures | PlainMessage<BlockedInfrastructures> | undefined, b: BlockedInfrastructures | PlainMessage<BlockedInfrastructures> | undefined): boolean {
    return proto3.util.equals(BlockedInfrastructures, a, b);
  }
}

